module.exports = "/_next/static/resources/photo-4-40c4485a0adbea2ad4dc1dec5f56e2ed.webp";